import domtoimage from 'dom-to-image';
import * as jsPdf from 'jspdf';
import * as moment from 'moment-timezone';
import * as React from 'react';
import * as ReactDom from 'react-dom';
import { ITest, IWellStory } from 'src/Interfaces/TestInterface';
import { IWell } from 'src/Interfaces/WellInterface';
import { equalGrid, mudPropertyHeaderShading } from '../MudReport/DrawReportMud';
import { textArrayInBoxes } from '../PopulateDataMethods';
import * as MM from './SpecMilsWellStory';

const drawReportWellStory = (test: ITest, well: IWell, wellStory: jsPdf) => {
    drawWellStoryHeader(well, wellStory);
    return drawWellStoryBody(test, wellStory);
};

const drawWellStoryHeader = (well: IWell, wellStory: jsPdf) => {
    wellStory.setFillColor(MM.HEADER_COLOR);
    wellStory.setLineWidth(MM.INNER_BORDER_WIDTH);
    wellStory.setDrawColor(MM.INNER_BORDER_COLOR);
    mudPropertyHeaderShading(MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.FULL_WIDTH, MM.TABLE_HEIGHT, MM.TABLE_ROWS, wellStoryHeaderShading, wellStory);
    equalGrid(MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.FULL_WIDTH, MM.TABLE_HEIGHT, MM.TABLE_ROWS, 4, wellStory);
    wellStory.rect(MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.FULL_WIDTH, MM.TABLE_HEIGHT);

    const headers = [
        ['Company Name', 'Well Name', 'Well Type', 'Target Formation'],
        undefined,
        ['Operator', 'Region', 'API Number', 'Sidetrack Number'],
        undefined,
        ['Contractor', 'Rig Number', 'State', 'County/Parish'],
        undefined,
        ['Group Email', 'AFE Number', 'Start Date', 'Spud Date'],
        undefined
    ];
    wellStory.setFontSize(9);
    wellStory.setFontStyle('bold');
    textArrayInBoxes(headers, MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.FULL_WIDTH, MM.TABLE_HEIGHT, 'left', wellStory);
    
    const data = [
        undefined,
        ['Nova Mud', well.wellName, well.wellType, well.targetFormation],
        undefined,
        [well.operator.operatorName, well.region.name, well.apiNumber, well.sidetrack],
        undefined,
        [well.contractor.contractorName, well.rigNumber, well.state, well.countyParish],
        undefined,
        [
            well.groupEmail,
            well.afeNumber,
            well.startDate === '' ? '' : moment.unix(Date.parse(well.startDate) / 1000).tz('utc').format('MM/DD/YYYY'),
            well.spudDate === '' ? '' : moment.unix(Date.parse(well.spudDate) / 1000).tz('utc').format('MM/DD/YYYY')
        ]
    ];
    wellStory.setFontStyle('normal');
    textArrayInBoxes(data, MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH, MM.FULL_WIDTH, MM.TABLE_HEIGHT, 'center', wellStory);
    
};

const drawWellStoryBody = (test: ITest, wellStory: jsPdf) => {
    return new Promise((resolve, reject) => {
        try {
            const wellStoryList = document.getElementById('my-hidden-div');
            if (wellStoryList && test.remarks.wellStories.length > 0 ) {
                ReactDom.render(renderWellStory(test), wellStoryList, () => {
                    // wellStory.addHTML(wellStoryList, MM.PAGE_BORDER_WIDTH, MM.PAGE_BORDER_WIDTH + MM.TABLE_HEIGHT, {}, () => {});
                    const addHeight = wellStoryList.scrollHeight;
                    const pageHeight = (wellStory.internal.pageSize.height - MM.PAGE_BORDER_WIDTH * 2) * MM.CONVERT_TO_PIXEL;
                    let imgHeightRemaining = wellStoryList.scrollHeight;
                    domtoimage.toJpeg(wellStoryList, {bgcolor: 'white'})
                    .then((canvas) => {
                        wellStoryList.hidden = true;
                        wellStory.addImage(canvas, 'PNG', MM.PAGE_BORDER_WIDTH, MM.TABLE_HEIGHT + MM.PAGE_BORDER_WIDTH * 2);
                        imgHeightRemaining -= ((wellStory.internal.pageSize.height - ( MM.PAGE_BORDER_WIDTH * 3 + MM.TABLE_HEIGHT + MM.OFFSET)) * MM.CONVERT_TO_PIXEL);
                        while (imgHeightRemaining > 0) {
                            const position = imgHeightRemaining - addHeight;
                            wellStory.setFillColor(255);
                            wellStory.rect(0, wellStory.internal.pageSize.height - 5, wellStory.internal.pageSize.width, 5, 'F');
                            wellStory.addPage();
                            wellStory.addImage(canvas, 'PNG', MM.PAGE_BORDER_WIDTH, position / MM.CONVERT_TO_PIXEL + MM.OFFSET);
                            wellStory.setFillColor(255);
                            wellStory.rect(0, 0, wellStory.internal.pageSize.width, 5, 'F');
                            imgHeightRemaining -= (pageHeight - MM.OFFSET * MM.CONVERT_TO_PIXEL);
                        }
                        wellStoryList.textContent = '';
                        resolve();
                    });
                });
            } else {
                reject();
            }
        }
        catch (error) {
            reject(error);
        }
    });
};

const renderWellStory = (test: ITest) => {
    return (
        <div className="RemarksA">
            <h4 style={{width: `${MM.FULL_WIDTH}mm`}}>Well Story</h4>
            <div id="well-story" className="well-story" style={{width: `${MM.FULL_WIDTH}mm`, padding: '0', maxHeight: 'none', overflowY: 'hidden'}}>
            { test.remarks.wellStories &&
                test.remarks.wellStories.sort((a, b) => Number(a.remarkSubmittedDate) - Number(b.remarkSubmittedDate)).map((story: IWellStory, index: number) =>
                    <div key={index} style={{marginRight: '0'}}>
                    {story.remarkText.split('\n').map((remark, indexRem) => {
                            if(remark === '') {
                                return <br key={indexRem} />;
                            }
                            return <p key={indexRem} className="the-remark">{remark}</p>;
                        })
                        }
                        <p className="remark-datetime">
                            {story.remarkSubType + ' | ' + moment(story.remarkSubmittedDate, 'X').format('LLL')}
                        </p>
                    </div>
            ) }
            </div>
        </div>
    );
};



const wellStoryHeaderShading = [
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
];

export { drawReportWellStory, drawWellStoryBody };




// WEBPACK FOOTER //
// ./src/Services/Pdf/WellStoryReport/DrawReportWellStory.tsx